





import React, { useEffect ,useState} from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get("orderId");
    // console.log("mxisdisni:",orderId);
    const [loading, setLoading] = useState(true); // New state for loading
    const [message, setMessage] = useState("");  // New state for messages
    

useEffect(() => {
    if (orderId) {
        checkPaymentStatus(orderId); // ✅ Use OMO... here
    }
}, [orderId]);



const checkPaymentStatus = async (orderId) => {
    try {
        const tokenRes = await axios.post(`https://ramjitrust.org:4000/payment/get-auth-token`);
        const token = tokenRes.data.access_token;

        // console.log("Token:", token);
        // console.log("Checking status for merchantOrderId:", orderId);

        const res = await axios.post(`https://ramjitrust.org:4000/payment/verify-payment`, {
            orderId,
            token,
        });
         
        const state = res.data?.state;
        // console.log("Payment status:", state); 
        setLoading(false);


        if (state === "COMPLETED") {
            setMessage("✅ Payment Successful");
            alert("✅ Payment Successful");
        
            const finalRes = await axios.post(`https://ramjitrust.org:4000/form/submit-temp`, {
                orderId,
            });
        
            if (finalRes.status === 200) {
                alert("🎉 Registration completed successfully!");
            } else {
                alert("⚠ Registration finalization failed.");
            }
        
            

        } else if (state === "FAILED") {
            alert("❌ Payment Failed");
        } else if (state === "PENDING") {
            alert("⏳ Payment is still pending");
        } else {
            alert(`ℹ Payment status: ${state}`);
        }
    } catch (error) {
        console.error("Error fetching payment status:", error.response?.data || error.message);
        alert("❌ Could not verify payment.");
    }
};



    return (
        <div style={{ padding: 20 }}>
             <h2>Please note your student ID for your examination</h2>
            {loading ? (
                <h1>Checking payment status...</h1> // Show loading message
            ) : (
                <h1>{message}</h1> // Show result after payment verification
            )}
        </div>
    );
};

export default PaymentSuccess;




